import { h } from 'vue'

import OrganizationMemberDialogContent from '@/components/admin/organization-manage/OrganizationMemberDialogContent.vue'

import { eventEmitter } from '@/utils/events/event-emitter'

import { CommonEvent } from '@/constant/events'

import type { Organization } from '@/types/organization'

export interface OrganizationMemberDialogOptions {
  organizationData: Organization
  isDisplayedOnFrontend?: boolean
}

export const useOrganizationMemberDialog = () => {
  /**
   * 開啟組織成員彈窗
   */
  const openOrganizationMemberDialog = (options: OrganizationMemberDialogOptions) => {
    const { organizationData, isDisplayedOnFrontend = false } = options

    const handleClose = () => {
      eventEmitter.emit(CommonEvent.CLOSE_DIALOG)
    }

    // 開啟彈窗
    eventEmitter.emit(CommonEvent.OPEN_DIALOG, {
      title: `新增 ${organizationData.companyOrganizationName} 的組織成員`,
      children: () =>
        h(OrganizationMemberDialogContent, {
          organizationData,
          isDisplayedOnFrontend,
          onClose: handleClose
        }),
      dialogProps: {
        width: '600px',
        destroyOnClose: true
      }
    })
  }

  return {
    openOrganizationMemberDialog
  }
}
